<p-dialog
  [header]="'CONSENT.HEADER' | translate"
  [modal]="true"
  [visible]="show()"
  [draggable]="false"
  [closable]="false"
>
  <p class="message" data-qa="dialog-box-content-message">{{ "CONSENT.MESSAGE" | translate }}</p>
  <section class="container--dialog cookie-consent--dialog">
    <div class="cookie-consent-options">
      <div class="tw:flex tw:items-center tw:gap-3 tw:leading-4">
        <p-checkbox
          name="consent"
          data-qa="cookie-consent-necessary"
          [binary]="true"
          inputId="necessary"
          [(ngModel)]="consentModel().necessary"
          [disabled]="true"
        />
        <label for="necessary">{{ "CONSENT.NECESSARY" | translate }}</label>
      </div>
      <div class="tw:flex tw:items-center tw:gap-3 tw:leading-4">
        <p-checkbox
          name="consent"
          data-qa="cookie-consent-analytics"
          [binary]="true"
          inputId="analytics"
          [(ngModel)]="consentModel().analytics"
        />
        <label for="analytics">{{ "CONSENT.ANALYTICS" | translate }}</label>
      </div>
    </div>
    <div class="footer">
      <p-button data-qa="button-cookies-consent-confirm" (onClick)="acceptAll()">{{
        "CONSENT.ACCEPT_ALL" | translate
      }}</p-button>
      <p-button data-qa="button-cookies-consent-selection" (onClick)="acceptSelected()">{{
        "CONSENT.ACCEPT_SELECTED" | translate
      }}</p-button>
      <p-button data-qa="button-cookies-consent-reject" (onClick)="reject()">{{
        "CONSENT.REJECT" | translate
      }}</p-button>
    </div>
  </section>
</p-dialog>
